export const GROUP_APPOINTMENT_REQUEST='GROUP_APPOINTMENT_REQUEST'
export const GROUP_APPOINTMENT_SUCCESS='GROUP_APPOINTMENT_SUCCESS'
export const GROUP_APPOINTMENT_FAILED='cGROUP_APPOINTMENT_FAILED'